<template>
  <div class="options-container">
    <div
      v-for="(item, index) in options"
      :key="item.value"
      class="text-center m-2 select-unselect-tooltip"
      :class="[
        {
          'is-selected': item.isSelected,
          'img-button': !item.isSelected,
          'btn-lighter':
            item.type && item.type !== 'multiple' && multipleSelected,
        },
      ]"
      @click="selectButton(index)"
      :data-cy="`${dataCy}-${item.value}`"
    >
      <span
        class="d-flex align-items-center justify-content-center"
        :class="[
          { 'without-icon': !item.icon, 'trade-content-class': isTradeOption },
        ]"
        style="padding: 0.5rem"
      >
        <span v-if="item.value === 'money'" class="options-title title-cash"
          >Cash</span
        >
        <span v-if="item.value === 'points'" class="options-title title-points"
          >Points</span
        >
        <div v-if="item.value === 'points'" class="points-div-hexagon">
          <em
            class="material-category-icon mr-1"
            :class="[item.iconClass]"
            v-if="item.tradeIcon"
            width="10px"
            height="10px"
            >{{ item.tradeIcon }}

          </em>
          <div :class="[{ 'trade-text-class': isTradeOption }]">
            {{ item.option.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
          </div>
        </div>
        <div
          v-else
          :class="[{ 'trade-text-class': isTradeOption }]"
        >
          ${{ (+item.option.replace('$', '')).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
        </div>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectTradeButtonsMaterial.vue",
  props: ["options", "savedOption", "dataCy", "isRemovable", "isTradeOption"],
  data() {
    return {
      option: null,
      multipleSelected: false,
    };
  },
  methods: {
    selectButton(index) {
      if (!this.isRemovable) {
        if (
          this.options[index].type &&
          this.options[index].type === "multiple"
        ) {
          this.validateMultipleChoice(index);
        } else {
          this.multipleSelected = false;
          this.option = this.options[index].value;
          this.$emit("value", this.option);
          if (this.options.some((item) => item.isSelected === true)) {
            this.options.forEach((element) => {
              if (element.isSelected === true) {
                element.isSelected = false;
              }
            });
          }
          this.options[index].isSelected = true;
        }
      }
    },
    validateMultipleChoice(index) {
      if (this.options[index].isSelected === true) {
        const i = this.option.indexOf(this.options[index].value);
        this.option.splice(i, 1);
        this.options[index].isSelected = false;
        if (this.option.length === 0) {
          this.multipleSelected = false;
        }
      } else {
        this.multipleSelected = true;
        if (
          this.options.some(
            (item) =>
              item.isSelected === true && item.type && item.type !== "multiple"
          )
        ) {
          this.options.forEach((element) => {
            if (
              element.isSelected === true &&
              element.type &&
              element.type !== "multiple"
            ) {
              element.isSelected = false;
            }
          });
          this.option = [];
        }
        if (!Array.isArray(this.option)) {
          this.option = [];
        }
        this.option.push(this.options[index].value);
        this.options[index].isSelected = true;
      }
      this.$emit("value", this.option);
    },
  },
  watch: {
    savedOption(newValue) {
      if (newValue) {
        this.option = this.savedOption;
      }
      if (
        this.options.some((option) => {
          if (option.type === "multiple" && option.isSelected === true) {
            return true;
          }
        })
      ) {
        this.multipleSelected = true;
      } else {
        this.multipleSelected = false;
      }
    },
  },
  mounted() {
    if(this.options.length === 1) {
      this.selectButton(0);
    }
  }
};
</script>

<style lang="scss" scoped>
.options-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.select-unselect-tooltip {
  background: $white;
  border: 1px solid $primary;
  border-radius: 4px;
  cursor: pointer;
}
.trade-content-class {
  flex-direction: column;
}
.options-title {
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 1.25px;
  color: $primary;
}
.title-cash {
  padding-left: 4rem;
  padding-right: 4rem;
}
.title-points {
  padding-left: 3.7001rem;
  padding-right: 3.7001rem;
}
.trade-text-class {
  font-weight: 500;
  font-size: 18px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  color: $primary;
  margin-top: 0;
}
.points-div-hexagon {
  margin-left: -16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0.2rem;
}
.points-div-hexagon i {
  color: $primary;
}
.is-selected {
  background-color: $primary;
  color: $white;
  font-weight: bold;
  cursor: pointer;
  i {
    color: $white;
  }
  span {
    color: $white;
  }
  .trade-text-class {
    color: $white;
  }
}
</style>
